import type { ComscoreParams } from './types';
import type { COMSCORE_KEYWORD } from './constants';

// the inner body of this function cannot use any imported code; alls deps must be passed in
// so that it can be used inside the comscore script itself
export function getComscoreParams({
  comscoreId,
  parsedGuid,
  parsedEncodedZuid,
  keyword,
}: {
  comscoreId: string;
  parsedGuid?: string;
  parsedEncodedZuid?: string;
  keyword: typeof COMSCORE_KEYWORD;
}): ComscoreParams {
  const isLoggedIn = parsedEncodedZuid !== 'null' && Boolean(parsedEncodedZuid);
  const uid = isLoggedIn ? parsedEncodedZuid : parsedGuid;

  return {
    c1: '2',
    c2: comscoreId,
    c3: '*null',
    c4: window.location.href,
    c5: '*null',
    c6: '*null',
    c15: '*null',
    cs_fpdm: '*null',
    cs_fpdt: '*null',
    cs_fpid: uid || '*null',
    // `*null` is for users that block cookies
    cs_fpit: isLoggedIn ? 'li' : parsedGuid ? 'lo' : '*null',
    options: {
      url_append: keyword,
    },
  };
}

export const isZillowProd = () => window.location.hostname === 'www.zillow.com';

export function parseGuid(guid?: string) {
  return guid?.replace(/2[34]\|%24/g, '');
}
